<template>

    <div class="alerts">
        <transition-group name="alert">
            <v-alert-container v-for="alert in alerts" :key="alert.key" :alert="alert" />
        </transition-group>
    </div>

</template>

<style scoped lang="scss">

    .alerts {
        margin: 20px;
        min-width: 300px;
        position: fixed;
        right: 0;
        top: 0;
        width: 30%;
        z-index: 10002;
    }

</style>

<script>

export default {

    mounted() {
        // Listen to updates for authed user.
        if (window.Echo) {
            window.Echo.private('user.' + this.$store.getters.user.id)
                .listen('.alert', e => {
                    this.$store.commit('setAlert', {
                        message: e.message,
                        type: e.type,
                    });
                });
        }
    },

    beforeDestroy() {
        if (window.Echo) window.Echo.leave('.alert');
    },

    computed: {

        alerts() {
            return this.$store.getters.alerts;
        },

    },

}

</script>
